import { injectModels } from "../../../redux/injectModels";
import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import { toast } from "react-toastify";
import { GlobalSettingService } from "../../../services";
import { Link, useParams } from "react-router-dom";
import { routes } from "../../../constants/routes";
import ReactPaginate from "react-paginate";
import { Modal, Button, Table } from "react-bootstrap";
import { EventService } from "../../../services";
import { handleConsoleError } from "../../../utils/common-methods";

const GlobalSettingModel = {
  id: "",
  keyName: "",
  keyValue: "",
  isActive: false,
};

const GlobalSettings = (props) => {
  const { eventId } = useParams();
  const [showModal, setShow] = useState(false);
  const [globalSettingData, setGlobalSettingData] = useState({
    ...GlobalSettingModel,
  });
  // const [error, setError] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [filteredData, setFilteredData] = useState([]);

  const {
    register,
    handleSubmit,
    reset,
    setError,
    formState: { errors },
  } = useForm();

  const rowsPerPage = 10; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  useEffect(() => {
    getData();
  }, []);

  //  ************  Global setting List Event *****************
  const getData = async () => {
    try {
      props.application.setLoading(true);
      const res = await GlobalSettingService.getEventGlobalSettingList(eventId);
      if (res?.isSuccess && res?.data?.length > 0) {
        setFilteredData(res?.data);
      }
      props.application.setLoading(false);
    } catch (error) {
      props.application.setLoading(false);
     const message= handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  // ******* Global setting  Edit **************************
  const handleEdit = async (id, name, value, status) => {
    try {
      props.application.setLoading(true);
      GlobalSettingModel.id = id;
      GlobalSettingModel.keyName = name;
      GlobalSettingModel.keyValue = value;
      GlobalSettingModel.isActive = status;

      reset(GlobalSettingModel);
      setGlobalSettingData(GlobalSettingModel);
      handleShow();
      props.application.setLoading(false);
    } catch (error) {
      props.application.setLoading(false);
      const message=handleConsoleError(error)
      toast.error(error?.message || message);
    }
  };

  //********* Global Setting Updates  ********/
  const onSubmit = async (data) => {
    try {
      props.application.setLoading(true);
      data.isActive = globalSettingData?.isActive;
      data.eventId = eventId;
      const response = await GlobalSettingService.EventUpdateGlobalSetting(
        data
      );

      if (response?.isSuccess) {
        toast.success(response?.message);
        getData();
        handleClose();
      } else {
        toast.error(response?.message);
      }
      props.application.setLoading(false);
    } catch (error) {
      props.application.setLoading(false);
      const message= handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  const handleIsStatus = (event) => {
    setGlobalSettingData({
      ...globalSettingData,
      isActive: event.target.checked ? true : false,
    });
  };

  const handleShow = () => setShow(true);
  const handleClose = () => {
    setShow(false);
    setError("");
  };

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };

  return (
    <React.Fragment>
      {/* <div className="pagetitle">
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={routes.ADMIN_DASHBOARD}>Dashboard</Link>
            </li>
            <li className="breadcrumb-item active">
              {" "}
              <i className="fa-solid fa-chevron-right"></i>Global Settings
            </li>
          </ol>
        </nav>
      </div> */}

      <Modal show={showModal} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton className="modal-main-header">
          <Modal.Title>Update Global Settings</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="keyName" className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                disabled
                maxLength={100}
                type="text"
                {...register("keyName", {
                  required: "Please enter key Name",
                })}
                defaultValue={globalSettingData?.keyName}
              />
              {errors.keyName && (
                <span className="text-danger">{errors.keyName?.message}</span>
              )}
            </Form.Group>

            <Form.Group controlId="keyValue" className="mb-3">
              <Form.Label>
                Value(£) <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                maxLength={100}
                type="text"
                {...register("keyValue", {
                  required: "Please enter Value",
                })}
                defaultValue={globalSettingData?.keyValue}
              />
              {errors.keyValue && (
                <span className="text-danger">{errors.keyValue?.message}</span>
              )}
            </Form.Group>

            <Form.Group controlId="isActive" className="mb-3">
              <Form.Label>Status</Form.Label>
              <Form.Check
                type="checkbox"
                defaultValue={globalSettingData?.isActive}
                checked={globalSettingData?.isActive} // Controlled by state
                onChange={handleIsStatus} // Handle change event
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            type="submit"
            variant="primary custom-button-colour"
            onClick={handleSubmit(onSubmit)}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="table-responsive">
        <div>{/* <h2>Global Settings</h2> */}</div>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Name</th>
              <th>Value(£)</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {paginatedData && paginatedData.length > 0 ? (
              <React.Fragment>
                {paginatedData.map((item, idx) => {
                  const nameMappings = {
                    "Bannerrail fortents Price": "Banner Rail Price",
                    "Trestletable Price": "Trestle table Price",
                    "Cost 1x16 Single": "1 x 16 amp single connection",
                  };

                  return (
                    <tr key={idx}>
                      <td>{calculateSNo(idx)}</td>
                      {/* <td>{item.keyName}</td> */}
                      <td>{nameMappings[item?.keyName] || item?.keyName}</td>
                      <td>{item?.keyValue}</td>
                      <td>
                        {" "}
                        {item?.isActive === true ? (
                          <i className="ri-check-fill"></i>
                        ) : (
                          <i className="ri-close-circle-line"></i>
                        )}
                      </td>
                      <td>
                        <div className="delete-create">
                          <Link
                            title="Edit Global Setting"
                            onClick={(e) => {
                              e.preventDefault();
                              handleEdit(
                                item?.id,
                                item?.keyName,
                                item?.keyValue,
                                item?.isActive
                              );
                            }}
                            style={{ marginRight: "10px" }}
                          >
                            <i className="ri-pencil-line"></i>
                          </Link>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </React.Fragment>
            ) : (
              <tr>
                <td colSpan="10 mt-2">No results found</td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>

      <div className="table-footer">
        <p className="mb-3">
          <strong>Total Count: {filteredData.length}</strong>
        </p>
        {filteredData.length === 0 ? "" : renderPagination()}
      </div>
    </React.Fragment>
  );
};

export default injectModels(["application"])(GlobalSettings);
